import { xBaseTheme } from "@guestsupply/XDL/types";

import accordion from "@guestsupply/XDL/PreStyle/accordion";
import breadcrumbs from "@guestsupply/XDL/PreStyle/breadcrumbs";
import breakpoints from "@guestsupply/XDL/PreStyle/breakpoints";
import button from "@guestsupply/XDL/PreStyle/button";
import checkbox from "@guestsupply/XDL/PreStyle/checkbox";
import clickable from "@guestsupply/XDL/PreStyle/clickable";
import colors from "@guestsupply/XDL/PreStyle/colors";
import dataTable from "@guestsupply/XDL/PreStyle/dataTable";
import datePicker from "@guestsupply/XDL/PreStyle/datePicker";
import drawer from "@guestsupply/XDL/PreStyle/drawer";
import dynamicDropdown from "@guestsupply/XDL/PreStyle/dynamicDropdown";
import fieldSet from "@guestsupply/XDL/PreStyle/fieldSet";
import fileUpload from "@guestsupply/XDL/PreStyle/fileUpload";
import focus from "@guestsupply/XDL/PreStyle/focus";
import formField from "@guestsupply/XDL/PreStyle/formField";
import globalStyle from "@guestsupply/XDL/PreStyle/globalStyle";
import header from "@guestsupply/XDL/PreStyle/header";
import helpers from "@guestsupply/XDL/PreStyle/helpers";
import icon from "@guestsupply/XDL/PreStyle/icon";
import lazyImage from "@guestsupply/XDL/PreStyle/lazyImage";
import link from "@guestsupply/XDL/PreStyle/link";
import lists from "@guestsupply/XDL/PreStyle/lists";
import loadingSpinner from "@guestsupply/XDL/PreStyle/loadingSpinner";
import menu from "@guestsupply/XDL/PreStyle/menu";
import modal from "@guestsupply/XDL/PreStyle/modal";
import overflowMenu from "@guestsupply/XDL/PreStyle/overflowMenu";
import pagination from "@guestsupply/XDL/PreStyle/pagination";
import panelMenu from "@guestsupply/XDL/PreStyle/panelMenu";
import radio from "@guestsupply/XDL/PreStyle/radio";
import select from "@guestsupply/XDL/PreStyle/select";
import shadows from "@guestsupply/XDL/PreStyle/shadows";
import tab from "@guestsupply/XDL/PreStyle/tab";
import tag from "@guestsupply/XDL/PreStyle/tag";
import textArea from "@guestsupply/XDL/PreStyle/textArea";
import textField from "@guestsupply/XDL/PreStyle/textField";
import toast from "@guestsupply/XDL/PreStyle/toast";
import tokenExFrame from "@guestsupply/XDL/PreStyle/tokenExFrame";
import tooltip from "@guestsupply/XDL/PreStyle/tooltip";
import transition from "@guestsupply/XDL/PreStyle/transition";
import translate from "@guestsupply/XDL/PreStyle/translate";
import typography from "@guestsupply/XDL/PreStyle/typography";
import zIndex from "@guestsupply/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    formField,
    // fieldSet,
    // icon,
    link,
    lists,
    // lazyImage,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    tooltip,
    // translate,
    helpers,
    header,
} as xBaseTheme;
